import React from 'react';
import DonutIcon from '../DonutIcon';
import HorizontalBarIcon from '../HorizontalBarIcon';
import { ChartEnum } from '../../HoldingsCard';
import './styles.css';



// clicking on icon should setActiveState
const HoldingsTabIcons = ({ activeChart, setActiveChart }) => {

    return (
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <div className='holding-icon-container' onClick={() => setActiveChart(ChartEnum.DONUT)}>
                <div className={`holding-icon ${activeChart === ChartEnum.DONUT ? 'active' : ''}`}>
                    <DonutIcon />
                    <div style={{ fontSize: '10px' }}>Donut</div>
                </div>
            </div>

            <div className='holding-icon-container' onClick={() => setActiveChart(ChartEnum.HORIZONTAL_BAR)}>
                <div className={`holding-icon ${activeChart === ChartEnum.HORIZONTAL_BAR ? 'active' : ''}`}>
                    <HorizontalBarIcon />
                    <div style={{ fontSize: '10px' }}>Bar</div>
                </div>
                
            </div>
        </div>
    )
}

export default HoldingsTabIcons;